import {ColorThumb as AriaColorThumb, ColorThumbProps} from 'react-aria-components';

import './ColorThumb.css';

export function ColorThumb(props: ColorThumbProps) {
  return <AriaColorThumb {...props} />;
}